import { PrizmLanguageInputLayout } from '../../interfaces';

export const PRIZM_ENGLISH_INPUT: PrizmLanguageInputLayout = {
  inputLayout: {
    required: 'Required field',
    pattern: 'Wrong format',
    min: 'Value too small',
    max: 'Value too large',
    clear: 'Clear',
  },
};
